const IMAGE_SLOTS_KEYS = {
  MOBILE_APP_COLOR_SELECTOR: 'mobile-app-color-selector',
  MOBILE_APP_BACKGROUND: 'mobile-app-background',
  RESTAURANT_LOGO: 'restaurant-logo',
  DEFAULT_KEY: 'default-key',
  DATA_EXTRACTION_SAMPLE_IMAGE: 'data-extraction-sample-image',
  EMPLOYEE_AVATAR: 'employee-avatar',
  ACCOUNT_AVATAR: 'account-avatar',
  DISH_IMAGE: 'dish-image',
  CATEGORY_IMAGE: 'category-image'
} as const

export default IMAGE_SLOTS_KEYS
